import React from 'react';
import { providerTemplates, ProviderTemplate } from './providerTemplates';

interface Props {
  selectedProvider: string;
  onProviderSelect: (providerId: string) => void;
}

const ProviderSelector: React.FC<Props> = ({ selectedProvider, onProviderSelect }) => {
  return (
    <div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        Select DNS Provider
      </h3>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(providerTemplates).map(([id, template]: [string, ProviderTemplate]) => (
          <div
            key={id}
            className={`relative rounded-lg border p-4 cursor-pointer transition-all ${
              selectedProvider === id
                ? 'border-indigo-600 ring-2 ring-indigo-600 bg-indigo-50'
                : 'border-gray-300 hover:border-gray-400 hover:bg-gray-50'
            }`}
            onClick={() => onProviderSelect(id)}
          >
            <div className="flex items-center">
              <span className="text-2xl mr-3">{template.icon}</span>
              <div className="min-w-0 flex-1">
                <label className="text-sm font-medium text-gray-900 cursor-pointer">
                  {template.name}
                </label>
                <p className="text-sm text-gray-500">{template.description}</p>
              </div>
              {selectedProvider === id && (
                <div className="absolute -inset-px rounded-lg border-2 border-indigo-600 pointer-events-none" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProviderSelector;